import { render, staticRenderFns } from "./EventWallActivityToggle.vue?vue&type=template&id=6581deb2"
import script from "./EventWallActivityToggle.vue?vue&type=script&lang=js"
export * from "./EventWallActivityToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports